(() => {
  const SIZE_OPTION_PATTERN = /size/i;
  const PLACEHOLDER_VALUE = '';
  const PLACEHOLDER_TEXT = 'Choose your size';

  const getOptionName = (control) => {
    const match = control.name?.match(/^options\[(.+)]$/);
    return match?.[1] || '';
  };

  const setSubmitState = (productInfo, disabled, text) => {
    const productForm = productInfo.querySelector('product-form');
    const submitButton = productForm?.querySelector('[type="submit"]');
    const submitButtonText = submitButton?.querySelector('span');

    if (!submitButton) return;

    submitButton.toggleAttribute('disabled', disabled);
    if (text && submitButtonText) submitButtonText.textContent = text;
  };

  const initializeProductInfo = (productInfo) => {
    if (!(productInfo instanceof HTMLElement) || productInfo.dataset.sizeSelectionInitialized === 'true') return;

    const variantPicker = productInfo.querySelector('variant-selects');
    if (!variantPicker) return;

    const sizeSelect = Array.from(variantPicker.querySelectorAll('select')).find((select) =>
      SIZE_OPTION_PATTERN.test(getOptionName(select))
    );

    const sizeFieldset = Array.from(variantPicker.querySelectorAll('fieldset')).find((fieldset) =>
      SIZE_OPTION_PATTERN.test(fieldset.querySelector('legend')?.textContent || '')
    );

    if (!sizeSelect && !sizeFieldset) return;

    productInfo.dataset.sizeSelectionInitialized = 'true';

    // A variant URL represents an intentional selection, so preserve it.
    if (new URLSearchParams(window.location.search).has('variant')) return;

    const productForm = productInfo.querySelector('product-form');
    const variantIdInput = productForm?.querySelector('input[name="id"]');
    const dynamicCheckout = productForm?.querySelector('.shopify-payment-button');

    if (sizeSelect) {
      const placeholder = document.createElement('option');
      placeholder.value = PLACEHOLDER_VALUE;
      placeholder.textContent = PLACEHOLDER_TEXT;
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.dataset.sizePlaceholder = 'true';
      sizeSelect.prepend(placeholder);
      sizeSelect.value = PLACEHOLDER_VALUE;
    } else {
      sizeFieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = false;
      });
    }

    if (variantIdInput) {
      variantIdInput.value = '';
      variantIdInput.disabled = true;
    }

    if (dynamicCheckout) dynamicCheckout.hidden = true;
    setSubmitState(productInfo, true, PLACEHOLDER_TEXT);

    const sizeControl = sizeSelect || sizeFieldset;
    sizeControl.addEventListener(
      'change',
      () => {
        setSubmitState(productInfo, true);

        if (!variantIdInput) return;

        const handleVariantUpdate = () => {
          if (!variantIdInput.value) return;

          variantIdInput.disabled = false;
          if (dynamicCheckout) dynamicCheckout.hidden = false;
          variantIdInput.removeEventListener('change', handleVariantUpdate);
        };

        variantIdInput.addEventListener('change', handleVariantUpdate);
      },
      { once: true }
    );
  };

  const initializeAll = () => {
    document.querySelectorAll('product-info').forEach(initializeProductInfo);
  };

  document.addEventListener('product-info:loaded', (event) => initializeProductInfo(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
